import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { FrameworkService } from './framework.service';
import { SysGlobals } from './sysglobals';
import { LocalStorageService } from './local-storage.service';
import { ResourcesService } from './resources.service';
import { ServiceBagService } from '@base/component/ServiceBag';
import { EnumLanguages } from '@m4u-angular/core/framework/sysenums.enum';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {

    private _languageSubject = new ReplaySubject<string>(1);
    public Language$ = this._languageSubject.asObservable();

    constructor(private frameworkService: FrameworkService,
        private resourcesService: ResourcesService,
        private A: ServiceBagService,
        private localStorageService: LocalStorageService) {}

    SetLanguage(language: string) {
        if (language == undefined) return;
        //Check if selected language resources file is loaded
        if (!this.resourcesService.IsSelectedLanguageLoaded(language)) {
            this.A.UI.StopMessage(`Selected language ${language} file is not exists in project.`);
            throw (`Selected language ${language} file is not exists in project.`);
            //return;
        }

        if (SysGlobals.Language !== language) {
            SysGlobals.Language = language; // TODO: REMOVE THAT
            this.localStorageService.SetItem("Language", language);
    
            this.frameworkService.InitLanguage();
            this.frameworkService.InitializeDevExpress();
        }

        this._languageSubject.next(language);
    }

    GetLanguage(): string {
        switch (SysGlobals.Language) {
            case EnumLanguages.Hebrew: {
                return "he";
            }
            case EnumLanguages.Spanish: {
                return "es-ES";
            }
            default: {
                return "en-US";
            }
        }
    }
}